export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const WOOT_PREFIX = 'chatwoot-widget:';

export const HIVER_COLOR = '#ffd301';

export const PRECHAT_COUNTRY_CODE_SEARCH_BOX_PALCEHOLDER = 'Search';

export const PRECHAT_PHONE_NUMBER_INPUT_PALCEHOLDER = 'Enter your phone number';

export const PRECHAT_PHONE_NUMBER_ERROR_MESSAGE = {
  EMPTY_PHONE_NUMBER: 'Please enter your phone number',
  EXAMPLE_NUMBER: 'Invalid number. Example of a valid phone number is ',
  INVALID_NUMBER: 'Invalid phone number',
}

export const TAB_TYPE = {
  HOME: 'home',
  CHAT: 'chat',
  HELP: 'help',
};

export const HIVER_HELP_URL = 'https://hiverhq.com/?utm_source=chat&utm_medium=powered_by_hiver&utm_campaign=freemium';